import instance from '../config/axios';
import { CartDetailType } from '../interface/interface';

export async function getCart(
  token: string,
): Promise<CartDetailType | undefined> {
  try {
    const result = await instance({
      url: '/api/v1/cart',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result.data;
  } catch (error) {
    return undefined;
  }
}
